import { ComponentGroup } from '../types.js'

const audio = new URL('../../../icons/components/audio.png', import.meta.url).href
const colorImage = new URL('../../../icons/components/color-image.png', import.meta.url).href
const gifImage = new URL('../../../icons/components/gif-image.png', import.meta.url).href
const grayImage = new URL('../../../icons/components/gray-image.png', import.meta.url).href
const text = new URL('../../../icons/components/text.png', import.meta.url).href

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
	  .st0{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-miterlimit:10;}
	  .st1{fill:{{strokeColor}};}
  </style>
  <g>
	  <polyline class="st0" points="20.6,12.8 20.6,5.1 1.6,5.1 1.6,18 15,18"/>
	  <path class="st1" d="M5.7,7.9c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6S6.6,7.9,5.7,7.9z"/>
	  <polygon class="st1" points="12.8,8.6 8.5,14.7 5.9,12.7 3.2,16.1 15.1,16.1 15.2,13.7"/>
	  <path class="st1" d="M24.1,15.1h2.1l0.6,2.8h1.7l-0.1-3.8H16.5l-0.1,3.8h1.7l0.4-2.8h2.1c0.1,2,0.1,3.1,0.1,5.2V21
		  c0,1.6,0,1.9,0,2.7l-1.8,0.2V25h6.9v-1.1L24,23.7c0-0.9,0-1.1,0-2.7v-0.7C24,18.1,24,17,24.1,15.1z"/>
  </g>
</svg>
`

export const textAndMedia: ComponentGroup = {
  name: 'textAndMedia',
  description: 'a group of text and various media components',
  icon,
  templates: [
    {
      type: 'text',
      description: 'text',
      icon: text,
      group: 'textAndMedia',
      model: {
        type: 'text',
        left: 100,
        top: 100,
        width: 200,
        height: 50,
        text: 'Text',
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 5,
        lineDash: 'solid',
        lineCap: 'butt',
        textAlign: 'left',
        textBaseline: 'top',
        textWrap: false,
        fontFamily: 'serif',
        fontSize: 30
      }
    },
    {
      type: 'color image',
      description: 'color image',
      icon: colorImage,
      group: 'textAndMedia',
      model: {
        type: 'image-view',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        isGray: false,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'audio',
      description: 'audio',
      icon: audio,
      group: 'textAndMedia',
      model: {
        type: 'audio',
        left: 100,
        top: 100,
        width: 100,
        height: 100
      }
    }
  ]
}
